// removed by extract-text-webpack-plugin
module.exports = {"fact-wrapper__content":"dh-dh-personlighetstest-fact-wrapper__content","move-content":"dh-dh-personlighetstest-move-content","fade-dots":"dh-dh-personlighetstest-fade-dots"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/components/FactBox/Fact.css
// module id = 62
// module chunks = 1